import { SchedulingViewState } from '../store/schema/SchedulingViewState';
import RequestStatus from '../store/schema/RequestStatus';

export default function getInitialSchedulingViewState(): SchedulingViewState {
    return {
        requestStatus: RequestStatus.NotInitiated,
        timeSuggestions: [],
        selectedTimeSuggestion: null,
        shouldShowRescheduleConfirmation: false,
        event: null,
    } as SchedulingViewState;
}
